import { Link } from "react-router-dom";

import { TeamMembersAvatar } from "./TeamMembersAvatar";
import { useTeamMembersQuery } from "./TeamMembersQuery";
import * as styles from "./TeamMembers.styles";

const TeamMembers = () => {
  const { loading, data } = useTeamMembersQuery();

  if (loading) return null;

  return (
    <div css={styles.teamMembers}>
      {data?.teamMembers?.map(({ slug, avatarMedium, name, position, phone }) => (
        <div key={slug} css={styles.teamMember}>
          <Link to={`/team_members/${slug}`}>
            <TeamMembersAvatar avatar={avatarMedium} name={name} />
          </Link>
          <div css={styles.info}>
            <h3 css={styles.name}>{name}</h3>
            <ul css={styles.infoList}>
              <li>{position}</li>
              <li>{phone}</li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export { TeamMembers };
